import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-423c462f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-pinglun" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-a-icon-32-shoucang2x1" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "icon collect-icon collected-icon",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-a-icon-32-yishoucang3x1" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "svg-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-fenxiang" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "btn-box" }

import {ref, computed, nextTick, watch} from 'vue';
import {Field, Badge, Overlay, Toast} from 'vant';
import {useUserInfo} from '@/hooks/useUserInfo';
import {useCommentPublish} from '@/service/comment';
import {toLoginPage} from '@/bridge';
import {haboClickReport} from '@/plugins/haboConfig';
import useUa from '@/hooks/useUa';
import {useCancelCollect, useCollect} from '@/service/detail';
import {throttle} from '@/utils/throttle';


const __default__ = {
  name: 'InputComponent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isCollect: { type: Boolean },
    showPopup: null,
    handleToggleBtn: null,
    informationId: null,
    firstPageRefetch: null,
    hideComment: { type: Boolean },
    total: null,
    changeIsRefresh: null
  },
  setup(__props: any) {

const props = __props as {
  isCollect: boolean;
  showPopup:() => void;
  handleToggleBtn: (comment?: true, commentNumber?: string) => void;
  informationId: number;
  firstPageRefetch: any;
  hideComment: boolean;
  total: number;
  changeIsRefresh: (refresh: boolean) => void;
}


const fieldRef = ref<any>(null);
const commentInput = ref<string>('');
watch(commentInput, () => {
  if (commentInput.value.length === 500) {
    Toast({
      message: '最多能输入500字哦~',
      position: 'bottom',
    });
  }
});
const commentTextWithTrim = computed(() => commentInput.value.trim());
const isPublishing = ref<boolean>(false); // 正在请求发表接口, 这里可以直接取 useCommentPublish 中的 isFetching, 待优化
const handlePublish = () => {
  // 评论发表
  if (commentTextWithTrim.value) {
    isPublishing.value = true;
    const {execute, data} = useCommentPublish(
      commentTextWithTrim.value,
      props.informationId,
    );
    execute().then(
      () => {
        props.changeIsRefresh(true);
        props.firstPageRefetch().then(() => {
          props.changeIsRefresh(false);
          // 定位到新发表的评论
          props.handleToggleBtn(true, data.value?.commentDetail.commentNumber);
          isPublishing.value = false;
          commentInput.value = '';
          isFieldFocus.value = false;
          Toast.success('发布成功');
        });
      },
      (err: any) => {
        props.changeIsRefresh(false);
        isPublishing.value = false;
        fieldRef.value.blur();
        isFieldFocus.value = false;
        const {code} = err;
        switch (+code) {
        case 3: {
          Toast({
            message: '休息一下再评论吧~',
            position: 'bottom',
          });
          break;
        }
        case 4: {
          Toast({
            message: '不能发布敏感词哦~',
            position: 'bottom',
          });
          break;
        }
        case 16: {
          // 登录过期, 跳转到登录页
          toLoginPageHandler(); // 跳转登录页
          break;
        }
        case 0: { // 关闭评论区返回状态吗也是0
          Toast.fail(err.msg || '发布评论失败');
          props.firstPageRefetch();
          break;
        }
        default: {
          Toast.fail('发布评论失败');
          break;
        }
        }
      },
    );
    haboClickReport('PUBLISH_BTN_CLICK', {
      news_id: props.informationId,
    });
  }
};

// 记录 input 的 focus blur
const isFieldFocus = ref<boolean>(false);

const handleInputContainerClick = () => {
  if (!isFieldFocus.value) {
    return;
  }
  fieldRef.value.focus();
};

// 未登录不允许评论
const {sid: initSid} = useUserInfo();
const sid = ref(initSid);
const handleFocus = () => {
  if (isFieldFocus.value) {
    // fix: 这里由于从 input 切换到 textarea 会触发两次 @focus, 优化为 1 次处理
    return;
  }
  isFieldFocus.value = true;

  nextTick(() => {// 不写 nextTick 无法正常 focus
    handleInputContainerClick();
  });
  haboClickReport('COMMENT_INPUT_CLICK', {
    news_id: props.informationId,
  });
};

const toLoginPageHandler = () => {
  toLoginPage(data => {
    sid.value = data.sid;
    history.replaceState({}, '', `${location.href}&sid=${data.sid}`);
  });
};
// 实测 click 只有在 focus 触发不了的时候才会触发
const handleInputClick = () => {
  if (!sid.value) {
    toLoginPageHandler(); // 跳转登录页
  }
};

const {outOpenParams} = useUa();
const isBrowser = ref<boolean>(outOpenParams.channel === 'browser');
const handleShare = () => {
  if (isBrowser.value) {
    // 端外不允许分享
    return;
  }
  props.showPopup();
  haboClickReport('INFO_ARTICLE_SHARE_CLICK', {
    news_id: props.informationId,
  });
};

// 收藏图标状态, 初始状态从详情取得
const isCollectDraft = ref<boolean>(props.isCollect);

// 收藏/取消收藏
const handleCollect = throttle((isCollect: boolean) => {
  if (isBrowser.value) {
    // 端外不允许收藏
    return;
  }
  if (isCollect) {
    useCollect(props.informationId, () => {
      isCollectDraft.value = true;
      Toast.success('收藏成功');
      haboClickReport('ARTICLE_COLLECT_BTN', {
        news_id: props.informationId, // 资讯 id
        collect_state: 1, // 收藏 0-取消收藏 1-收藏
      });
    });
  }
  else {
    useCancelCollect(props.informationId, () => {
      isCollectDraft.value = false;
      Toast.success('已取消收藏');
      haboClickReport('ARTICLE_COLLECT_BTN', {
        news_id: props.informationId,
        collect_state: 0,
      });
    });

  }
}, 1500);

// 文章和评论切换
const toggleArticlePosition = () => {
  props.handleToggleBtn();
  haboClickReport('COMMENT_ICON_CLICK', {
    news_id: props.informationId,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "input-container",
      style: _normalizeStyle(isFieldFocus.value ? { paddingBottom: '12px' } : {}),
      onClick: handleInputContainerClick
    }, [
      (!__props.hideComment)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isFieldFocus.value)
              ? (_openBlock(), _createBlock(_unref(Field), {
                  key: 0,
                  ref_key: "fieldRef",
                  ref: fieldRef,
                  modelValue: commentInput.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((commentInput).value = $event)),
                  rows: "3",
                  border: false,
                  class: "input-area",
                  style: {marginRight: '16px'},
                  placeholder: "有爱评论, 说点儿什么吧~",
                  autosize: { maxHeight: 66 },
                  maxlength: "500",
                  type: "textarea",
                  disabled: !sid.value,
                  onClick: _withModifiers(handleInputClick, ["stop"]),
                  onFocus: handleFocus
                }, null, 8, ["modelValue", "disabled", "onClick"]))
              : (_openBlock(), _createBlock(_unref(Field), {
                  key: 1,
                  ref_key: "fieldRef",
                  ref: fieldRef,
                  modelValue: commentInput.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((commentInput).value = $event)),
                  rows: "3",
                  border: false,
                  class: "input-area",
                  style: {marginRight: 0},
                  placeholder: "有爱评论, 说点儿什么吧~",
                  maxlength: "500",
                  type: "text",
                  disabled: !sid.value,
                  onClick: _withModifiers(handleInputClick, ["stop"]),
                  onFocus: handleFocus
                }, null, 8, ["modelValue", "disabled", "onClick"])),
            _withDirectives(_createVNode(_unref(Badge), {
              content: __props.total,
              max: "999",
              "show-zero": false,
              offset: [0, 10],
              color: "#fff",
              class: "badge"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", {
                  class: "icon comment-icon",
                  "aria-hidden": "true",
                  onClick: toggleArticlePosition
                }, _hoisted_2))
              ]),
              _: 1
            }, 8, ["content"]), [
              [_vShow, !isFieldFocus.value]
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(`${__props.hideComment?'svg-box':'svg-box-default'}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`svg-item ${isCollectDraft.value && 'gray'}`),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(handleCollect)(!isCollectDraft.value)))
        }, [
          (!isFieldFocus.value && !isCollectDraft.value)
            ? (_openBlock(), _createElementBlock("svg", {
                key: 0,
                class: _normalizeClass(`icon collect-icon ${isBrowser.value ? 'disabled-icon' : ''}`),
                "aria-hidden": "true"
              }, _hoisted_4, 2))
            : _createCommentVNode("", true),
          (!isFieldFocus.value && isCollectDraft.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          (__props.hideComment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(isCollectDraft.value?'已收藏':'收藏'), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(`icon share-icon ${isBrowser.value ? 'disabled-icon' : ''}`),
            "aria-hidden": "true",
            onClick: handleShare
          }, _hoisted_11, 2)), [
            [_vShow, !isFieldFocus.value]
          ]),
          (__props.hideComment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "分享"))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("span", {
          class: _normalizeClass(
          _unref(commentTextWithTrim) && !isPublishing.value
            ? 'publish-btn'
            : 'publish-btn-disable'
        ),
          onClick: handlePublish
        }, " 发表 ", 2), [
          [_vShow, isFieldFocus.value]
        ]),
        _withDirectives(_createElementVNode("span", { class: "text-length" }, _toDisplayString(commentInput.value.length) + "/500", 513), [
          [_vShow, isFieldFocus.value]
        ])
      ])
    ], 4),
    _createVNode(_unref(Overlay), {
      show: isFieldFocus.value,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (isFieldFocus.value = false))
    }, null, 8, ["show"])
  ], 64))
}
}

})